<template>
  <el-card shadow="never">
    <el-form ref="contact-form" :rules="rules" style='margin:0px;'>
      <el-button style="position:relative;float:right; padding: 3px 0;margin-left:10px;" type="text" @click="$emit('remove')"><i class="el-icon-delete"/></el-button>
      <el-row :gutter="10" style="margin-right:30px">
        <el-col>
          <span>{{contact.first_name}} {{contact.last_name}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item label="Role"  style="margin-bottom:0px;">
            <el-select
              v-model="roleModel"
              filterable
              allow-create
              clearable
              size="small"
              value-key="id"
              :placeholder="$t('contacts.selectRole')"
              >
              <el-option
                v-for="item in companyRoles"
                :key="item.id"
                :label="item.code"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('contacts.professionalEmail')" prop="emailModel" style="margin-bottom:0px;">
            <el-input size="small" v-model="emailModel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('contacts.professionalPhone')" style="margin-bottom:0px;">
            <PhoneComponent size="small" :data="{phone : phoneModel, ext : extModel}" @updatePhone="v => phoneModel=v" @updateExt="v => extModel=v"></PhoneComponent>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item style="margin-bottom:0px;">
            <div class="hidden-md-and-down" style="margin-top:40px;"/>
           <el-checkbox v-model="primary">{{$t('contacts.principal')}}</el-checkbox>
           <el-checkbox v-model="default_billing">{{$t('contacts.defaultBillingContact')}}</el-checkbox>
           <el-checkbox v-model="default_shipping">{{$t('contacts.defaultShippingContact')}}</el-checkbox>
           <el-checkbox v-model="send_invoice_notice">{{$t('contacts.receiveBillingNotices')}}</el-checkbox>
           <el-checkbox v-model="send_reservation_orders_ind">{{$t('contacts.receiveFollowup')}}</el-checkbox>
         </el-form-item>
        </el-col></el-row>
    </el-form>
  </el-card>
</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';
import portausUtil from '@/utils/portaus-utils'
import PhoneComponent from '@/components/phone.vue'
import axios from 'axios'

export default {
	name: 'CompanyContactFlatEditor',
  props: {
    contact : {
      type : Object,
      require : true
    },
    index : {
      type : Number,
      require : true
    }
	},
	data() {
		return {
      rules : {
          emailModel : [
            { type: 'email', message: "Format de l'adresse courriel incorrect", trigger: ['blur', 'change'] }
          ],
      },
	   }
   },
   components : {
     PhoneComponent
   },
   methods : {
     ...mapActions('controlData', ['fetchCompanyRoles']),
     ...mapActions('customerEditor',['updateCompanyContactProperty'])
   },
   computed: {
    roleModel : {
      set(role){this.updateCompanyContactProperty({index:this.index,contactProps:{role}})},
      get(){return this.company.contacts[this.index].role}
    },
    emailModel : {
      set(work_email){this.updateCompanyContactProperty({index:this.index,contactProps:{work_email}})},
      get(){return this.company.contacts[this.index].work_email}
    },
    phoneModel : {
      set(work_phone){this.updateCompanyContactProperty({index:this.index,contactProps:{work_phone}})},
      get(){return portausUtil.getFormattedPhoneNumber(this.company.contacts[this.index].work_phone)}
    },
    extModel : {
      set(work_phone_ext){this.updateCompanyContactProperty({index:this.index,contactProps:{work_phone_ext}})},
      get(){return this.company.contacts[this.index].work_phone_ext}
    },
    primary : {
      set(primary){this.updateCompanyContactProperty({index:this.index,contactProps:{primary}})},
      get(){return this.company.contacts[this.index].primary}
    },
    send_invoice_notice : {
      set(send_invoice_notice){this.updateCompanyContactProperty({index:this.index,contactProps:{send_invoice_notice}})},
      get(){return this.company.contacts[this.index].send_invoice_notice}
    },
    send_reservation_orders_ind : {
      set(send_reservation_orders_ind){this.updateCompanyContactProperty({index:this.index,contactProps:{send_reservation_orders_ind}})},
      get(){return this.company.contacts[this.index].send_reservation_orders_ind}
    },
    default_billing : {
      set(default_billing_ind){this.updateCompanyContactProperty({index:this.index,contactProps:{default_billing_ind}})},
      get(){return this.company.contacts[this.index].default_billing_ind}
    },
    default_shipping : {
      set(default_shipping_ind){this.updateCompanyContactProperty({index:this.index,contactProps:{default_shipping_ind}})},
      get(){return this.company.contacts[this.index].default_shipping_ind}
    },
    ...mapState('controlData',['companyRoles']),
    ...mapState('customerEditor', ['company'])
  },
  mounted(){
    this.fetchCompanyRoles();
  }

}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.el-card__body{
  padding:0px;
}

</style>
